// extracted by mini-css-extract-plugin
export default {"table":"soil-table_table__HzkD9","inputError":"soil-table_inputError__1H3s-"};